module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/areas/area/textures/tile1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/areas/area/textures/tile1.jpg
// module id = 462
// module chunks = 0